import React, { useEffect, useState, useContext } from 'react';
import { ZustandContext } from '@store/modalStore';
import ReCAPTCHA from 'react-google-recaptcha';
import {
  Box,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
  TextField,
  Grid,
  FormControl,
  Autocomplete,
  Button,
} from '@mui/material';
import { FoundSearchText } from '@modals/ModalHome';
import { CarListData } from '@models/store/carListStore';
import { CustomButton } from '@buttons/CustomButton';
import { useSearchCarStore } from '@store/searchCarStore';
import { AnioCustomMask } from '@inputCustomMasks/AnioCustomMask';
import { useCarModalHomeStore } from '@store/ModalHomeStore';
import { initialCarListData, useCarListStore } from '@store/carListStore';
import { useCarStore } from '@store/carInfoStore';
import { useTokenStore } from '@store/TokenStore';
import { useTrackingStore } from '@store/TrackingStore';
import { years } from '@modals/ModalHome/Data';
import { getToken } from '@api/getToken';
import TagManager from 'react-gtm-module';
import { VehiculoType, useVehiculoStore } from '@store/vehiculoStore';
import CocheAzulIcon from '@assets/images/CocheAzul.svg';
import CocheGrisIcon from '@assets/images/CocheGris.svg';
import MotoAzulIcon from '@assets/images/MotoAzul.svg';
import MotoGrisIcon from '@assets/images/MotoGris.svg';
import PickupAzulIcon from '@assets/images/TrocaAzul.svg';
import PickupGrisIcon from '@assets/images/TrocaGris.svg';
import { HaveQuotationWrapper } from '@components/Tab/HaveQuotationWrapper';
import { datadogRum } from '@datadog/browser-rum';

type HeroActionProps = {
  title?: string;
  padding?: number;
  elevation?: number;
  isAbsolute?: boolean;
  onClose?: () => void;
  setShowSearchCar?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsNewQuotation?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsHeroAction: React.Dispatch<React.SetStateAction<boolean>>;
  setIsFormInformation?: React.Dispatch<React.SetStateAction<boolean>>;
};

export const HeroAction: React.FC<HeroActionProps> = ({
  elevation = 0,
  setIsNewQuotation,
  setIsHeroAction,
}) => {
  const { breakpoints } = useTheme();
  const isTablet = useMediaQuery(breakpoints.down('md'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const isDesktop = useMediaQuery(breakpoints.down('lg'));
  const { setCar, car: carModal } = useCarModalHomeStore();
  const { setCar: setCarStore } = useCarStore();
  const { assamblerList, getAssemblerList, getCarList, carList } =
    useCarListStore();
  const { car, setCar: setCarAssambler } = useCarStore();
  const { show, hide } = useContext(ZustandContext);
  const [marca, setMarca] = useState(car.assembler);
  const { searchCarFields, setMarcaModeloState, setAnioState, setIsError } =
    useSearchCarStore();
  const { setToken, token } = useTokenStore();
  const [recaptcha, setRecaptcha] = useState(false);
  const { tracking, setDataTracking } = useTrackingStore();
  const { setSelectedVehiculo } = useVehiculoStore();
  const [vehiculoSeleccionado, setVehiculoSeleccionado] =
    useState<VehiculoType>('coche');

  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      await setDataTracking(tracking);
      await getAssemblerList(
        await getToken(),
        vehiculoSeleccionado === 'coche'
          ? 'CAR'
          : vehiculoSeleccionado === 'camioneta'
          ? 'PICKUP'
          : 'MOTO'
      );
    })();
  }, []);

  useEffect(() => {
    if (!marca) setMarca(assamblerList[0]);
  }, [assamblerList]);

  const onChange = () => {
    setRecaptcha(true);
  };
  const [errorCheckbox, setErrorCheckbox] = useState({
    msg: '',
    isError: false,
  });
  const [acceptTnC, setAcceptTnC] = useState(false);

  const [data] = useState<CarListData[]>(carList);
  const [marcaModelo, setMarcaModelo] = useState('');
  const [anio, setAnio] = useState('');
  const [carListValue, setCarListValue] =
    useState<CarListData>(initialCarListData);

  const isValidForm = (): boolean => {
    if (anio === '' && searchCarFields.anio === '') {
      return false;
    } else if (
      (anio.length < 4 && searchCarFields.anio.length < 4) ||
      (anio.length > 4 && searchCarFields.anio.length > 4)
    ) {
      return false;
    } else if (
      +searchCarFields.anio < years[years.length - 1] ||
      +searchCarFields.anio > years[0]
    ) {
      return false;
    } else if (carModal.modelo === '') {
      return false;
    } else if (!recaptcha) {
      return false;
    }
    return true;
  };

  const foundProps = {
    hide,
    show,
    data,
    carList,
  };

  const traer = async () => {
    await getCarList(
      searchCarFields.marcaModelo.toUpperCase(),
      searchCarFields.anio,
      marcaModelo,
      token,
      vehiculoSeleccionado === 'coche'
        ? 'CAR'
        : vehiculoSeleccionado === 'camioneta'
        ? 'PICKUP'
        : 'MOTO'
    );
    setCarStore(
      carList.filter((item) =>
        item.description.toUpperCase().includes(carModal.modelo)
      )[0]
    );

    TagManager.dataLayer({
      dataLayer: {
        event: 'CSform_step_0_submit',
        eventCategoy: 'Formulario.Seguro.Auto.v2',
        eventAction: 'step_0_submit',
        eventLabel: 'Cotizar',
        telefono: undefined,
        correo: undefined,
        noCotizacion: undefined,
        modelo: carModal.modelo,
        marca: marca,
        anio: anio,
        paquete: undefined,
        forma_pago: undefined,
        aseguradora: undefined,
        tarjeta: undefined,
        tipo_tarjeta: undefined,
        tipo_vehiculo: carList[0].type,
        colaborador: undefined,
        cupon_: undefined,
      },
    });
    TagManager.dataLayer({
      dataLayer: {
        event: 'coche_seguro_modelo',
        marca: carModal.marca,
        anio: carModal.anio,
        modelo: carModal.modelo,
        boton_modelo: 'Continuar',
      },
    });
    setIsHeroAction && setIsHeroAction(false);
    setIsNewQuotation && setIsNewQuotation(true);
  };

  const handleChangeCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAcceptTnC(e.target.checked);
    setErrorCheckbox({
      msg: '',
      isError: false,
    });
  };

  const handleSubmit = () => {
    traer();
  };

  useEffect(() => {
    getCarList(
      carModal.marca,
      searchCarFields.anio,
      marca,
      token,
      vehiculoSeleccionado === 'coche'
        ? 'CAR'
        : vehiculoSeleccionado === 'camioneta'
        ? 'PICKUP'
        : 'MOTO'
    );
  }, [carModal.marca, searchCarFields.anio]);

  useEffect(() => {
    setSelectedVehiculo(vehiculoSeleccionado);
    (async () => {
      await getAssemblerList(
        await getToken(),
        vehiculoSeleccionado === 'coche'
          ? 'CAR'
          : vehiculoSeleccionado === 'camioneta'
          ? 'PICKUP'
          : 'MOTO'
      );
    })();
  }, [vehiculoSeleccionado]);

  const resetValues = () => {
    setCar({ anio: '', marca: '', modelo: '' });
    setMarcaModelo('');
    setMarcaModeloState('');
    setCarAssambler({
      assembler: '',
      description: '',
      insurers: [''],
      model: '',
      type: '',
      vehicle_id: '',
    });
    getCarList('fasdf', '1900', 'fsadf', token, '');
  };

  return (
    <Box
      sx={{
        backgroundColor: '#F2FAFC',
        padding: isMobile ? '28px' : isDesktop ? '72px' : '55.5px 150px',
      }}
    >
      {!isVisible ? (
        <Paper
          elevation={elevation}
          style={{
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            maxWidth: '1140px',
            margin: 'auto',
          }}
        >
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
            paddingY={'32px'}
            paddingX={isMobile ? '16px' : isTablet ? '70px' : '95px'}
          >
            <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                marginBottom={'24px'}
              >
                <Typography
                  fontWeight={'bold'}
                  sx={{
                    fontSize: '24px',
                    textAlign: 'center',
                  }}
                >
                  ¿List@ para cotizar?
                </Typography>
                <Typography sx={{ fontSize: '24px', textAlign: 'center' }}>
                  Vamos con los datos de tu vehículo
                </Typography>
              </Grid>
              <Grid
                item
                width={'100%'}
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                marginBottom={'24px'}
              >
                <Typography
                  textAlign={'start'}
                  variant={'caption'}
                  fontSize={'14px'}
                  style={{ fontWeight: '600' }}
                >
                  {'Tipo de vehículo:'}
                </Typography>
              </Grid>
              <Grid
                marginBottom={'24px'}
                sx={{
                  display: 'flex',
                  justifyContent: isMobile ? 'center' : 'left',
                  width: '100%',
                }}
              >
                {vehiculoSeleccionado === 'coche' && (
                  <Box
                    component={'img'}
                    src={CocheAzulIcon}
                    alt={'vehiculo'}
                    sx={{
                      cursor: 'pointer',
                      width: isMobile ? '94px' : '132px',
                    }}
                  />
                )}
                {vehiculoSeleccionado !== 'coche' && (
                  <Box
                    component={'img'}
                    src={CocheGrisIcon}
                    alt={'vehiculo'}
                    sx={{
                      cursor: 'pointer',
                      width: isMobile ? '94px' : '132px',
                    }}
                    onClick={() => {
                      setVehiculoSeleccionado('coche');
                      resetValues();
                      datadogRum.addAction("Botón de tipo de vehículo", { button: "coche" });
                    }}
                  />
                )}
                {vehiculoSeleccionado === 'moto' && (
                  <Box
                    component={'img'}
                    src={MotoAzulIcon}
                    alt={'vehiculo'}
                    sx={{
                      cursor: 'pointer',
                      width: isMobile ? '94px' : '132px',
                    }}
                  />
                )}
                {vehiculoSeleccionado !== 'moto' && (
                  <Box
                    component={'img'}
                    src={MotoGrisIcon}
                    alt={'vehiculo'}
                    sx={{
                      cursor: 'pointer',
                      width: isMobile ? '94px' : '132px',
                    }}
                    onClick={() => {
                      setVehiculoSeleccionado('moto');
                      datadogRum.addAction("Botón de tipo de vehículo", { button: "moto" });
                      resetValues();
                    }}
                  />
                )}
                {vehiculoSeleccionado === 'camioneta' && (
                  <Box
                    component={'img'}
                    src={PickupAzulIcon}
                    alt={'vehiculo'}
                    sx={{
                      cursor: 'pointer',
                      width: isMobile ? '94px' : '132px',
                    }}
                  />
                )}
                {vehiculoSeleccionado !== 'camioneta' && (
                  <Box
                    component={'img'}
                    src={PickupGrisIcon}
                    alt={'vehiculo'}
                    sx={{
                      cursor: 'pointer',
                      width: isMobile ? '94px' : '132px',
                    }}
                    onClick={() => {
                      setVehiculoSeleccionado('camioneta');
                      datadogRum.addAction("Botón de tipo de vehículo", { button: "camioneta" });
                      resetValues();
                    }}
                  />
                )}
              </Grid>
              <Grid
                item
                width={'100%'}
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                marginBottom={'20px'}
              >
                <Typography
                  textAlign={'start'}
                  variant={'caption'}
                  fontSize={'14px'}
                  style={{ fontWeight: '600' }}
                >
                  {'Marca y modelo:'}
                </Typography>
              </Grid>
              <Grid
                item
                container
                spacing={3}
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
              >
                <Grid item container xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Grid item xs={8}>
                    <FormControl fullWidth>
                      <Autocomplete
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px 0 0 8px',
                          },
                        }}
                        options={assamblerList}
                        value={carModal.marca}
                        onChange={(event: any, newValue: any) => {
                          setCarListValue(initialCarListData);
                          setMarca(newValue.toUpperCase());
                          setCar({
                            ...carModal,
                            marca: newValue.toUpperCase(),
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Escribe o selecciona la marca"
                            value={carModal.marca}
                            onChange={({ target: { value } }) => {
                              setMarca(value.toUpperCase());
                              setCar({
                                ...carModal,
                                marca: value.toUpperCase(),
                              });
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      label="Año"
                      placeholder="Año"
                      variant="outlined"
                      onChange={(e) => {
                        setAnio(e.target.value);
                        setAnioState(e.target.value);
                        if (
                          +e.target.value < years[years.length - 1] ||
                          +e.target.value > years[0]
                        ) {
                          setIsError(
                            `Modelos entre ${years[years.length - 1]} y ${
                              years[0]
                            }`,
                            true
                          );
                        } else {
                          setCar({ ...carModal, anio: e.target.value });
                          setIsError('', false);
                        }
                      }}
                      error={searchCarFields.isError}
                      helperText={searchCarFields.errorMsg}
                      value={searchCarFields.anio}
                      InputProps={{
                        inputComponent: AnioCustomMask as any,
                        style: {
                          borderRadius: '0 8px 8px 0',
                        },
                      }}
                      sx={{ width: '100%' }}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Autocomplete
                    disabled={!carModal.marca}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                      },
                    }}
                    value={carListValue}
                    options={carList}
                    getOptionLabel={(option) =>
                      carModal.marca === ''
                        ? ''
                        : option &&
                          `${option?.description ?? ''}`
                    }
                    onChange={(event: any, newValue: any) => {
                      setCarListValue(newValue);
                      setCar({
                        ...carModal,
                        modelo: newValue.description.toUpperCase(),
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Escribe o selecciona el modelo"
                        value={''}
                        onChange={({ target: { value } }) => {
                          setMarcaModelo(value.toUpperCase());
                          setMarcaModeloState(value.toUpperCase());
                          setCar({
                            ...carModal,
                            modelo: value.toUpperCase(),
                          });
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Box
              sx={{
                marginTop: '15px',
                marginBottom: '15px',
                display: 'flex',
                width: '100%',
                flexDirection: isMobile ? 'column' : 'unset',
              }}
            >
              <FoundSearchText
                {...foundProps}
                marca={marca}
                modelo={carModal.modelo}
                anio={anio}
                type={carList[0].type}
              />
            </Box>
            <Grid
              container
              spacing={1}
              justifyContent="flex-end"
              display="flex"
            >
              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <ReCAPTCHA
                  style={{
                    marginRight: isMobile || isTablet ? 'unset' : 34,
                  }}
                  sitekey="6LdUmWUjAAAAAFc8bJe83bvfGhDBf-Uh-q_0HEiy"
                  onChange={onChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                <CustomButton
                  disabled={!isValidForm()}
                  text={'Continuar'}
                  color={'primary'}
                  variant={'contained'}
                  style={{
                    width: '100%',
                    height: 56,
                    textTransform: 'none',
                  }}
                  onClick={handleSubmit}
                />
              </Grid>
            </Grid>
            <Grid
              sx={{
                display: 'flex',
                justifyContent: isTablet || isMobile ? 'center' : 'flex-end',
                marginTop: '24px',
              }}
            >
              <Button
                onClick={() => {
                  setIsVisible(true);
                }}
                variant={'text'}
                color={'primary'}
                style={{
                  padding: 0,
                  fontSize: 14,
                  fontWeight: 400,
                  textTransform: 'none',
                  textDecoration: 'underline',
                }}
              >
                {'¿Ya tienes un número de cotización?'}
              </Button>
            </Grid>
          </Box>
        </Paper>
      ) : (
        <HaveQuotationWrapper
          setIsHeroAction={setIsHeroAction}
          setShowHaveQuotation={setIsVisible}
        />
      )}
    </Box>
  );
};
